export default "__VITE_ASSET__CegIYyik__"